import  { useState } from "react";
import "../../styles/Newsletter.css"; // Assurez-vous de créer un fichier CSS pour styliser ce composant

export default function AdminNewsletter() {
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [recipients, setRecipients] = useState("all"); // Options: "all", "subscribers"
  const [message, setMessage] = useState(null);

  const handleSendNewsletter = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (!subject || !content) {
      setMessage({ type: "error", text: "Le sujet et le contenu de la newsletter sont obligatoires." });
      return;
    }

    try {
      // Remplacez cette URL par votre point de terminaison pour envoyer une newsletter
      const response = await fetch("/api/newsletter/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subject, content, recipients }),
      });

      if (!response.ok) {
        throw new Error("Une erreur s'est produite lors de l'envoi de la newsletter.");
      }

      setMessage({ type: "success", text: "La newsletter a été envoyée avec succès." });
      setSubject("");
      setContent("");
      setRecipients("all");
    } catch (error) {
      setMessage({ type: "error", text: error.message });
    }
  };

  return (
    <div className="admin-newsletter">
      <h2>Envoyer une newsletter</h2>
      <form onSubmit={handleSendNewsletter} className="newsletter-form">
        <div className="form-group">
          <label htmlFor="subject">Sujet :</label>
          <input
            type="text"
            id="subject"
            placeholder="Entrez le sujet de la newsletter"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="newsletter-input"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="content">Contenu :</label>
          <textarea
            id="content"
            placeholder="Entrez le contenu de la newsletter"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={10}
            className="newsletter-textarea"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="recipients">Destinataires :</label>
          <select
            id="recipients"
            value={recipients}
            onChange={(e) => setRecipients(e.target.value)}
            className="newsletter-select"
          >
            <option value="all">Tous les utilisateurs</option>
            <option value="subscribers">Abonnés à la newsletter</option>
          </select>
        </div>

        <button type="submit" className="newsletter-button">Envoyer</button>
      </form>
      {message && (
        <p className={`newsletter-message ${message.type}`}>{message.text}</p>
      )}
    </div>
  );
}
